import { render, staticRenderFns } from "./ChartPanel.vue?vue&type=template&id=736b2246&"
import script from "./ChartPanel.vue?vue&type=script&lang=js&"
export * from "./ChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChartPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports